<template>
  <div id="dashboard-feedback-jscode">
    <div id="alerts">
      <h1>Feedback Collection Form Link\URL Code</h1>
      <!-- eslint-disable -->
      This link can be used to capture feedback on emails, receipts, etc... <br>
      <textarea
        name="name"
        rows="5"
        cols="100">


https://www.machinecore.com/console/survey/{{ token }}

      </textarea>
      <!-- eslint-enable -->
      <br /><br />
      <h1>Documentation</h1>
      <router-link :to="{ path: '/console/survey/' + token }"
        >CLICK HERE</router-link
      >
      to see the feedback collection form. <br />
      <br />
      <h2>
        We suggest one of the following three methods for linking to the
        Feedback form:
      </h2>
      <h3>Custom Domain Redirect:</h3>
      We suggest that you create a URL using your domain name and use it in the
      actual email or receipt. This URL will redirect to MachineCore's above
      URL.
      <br />
      <br />
      example: <br />
      Create the following URL using your website's domain:
      https://www.abcstore.com/survey
      <br />
      <br />
      Then you use that URL to redirect to
      https://www.machinecore.com/console/survey/{{ token }}<br /><br />
      Contact your IT team to figure out the best way to perform a URL
      redirection
      <br /><br />
      <h3>Link Shortener</h3>
      Use a link shortening service to create a shortened URL to use on your
      emails or receipts.
      <br />
      Suggested Services: Bitly, TinyURL or Rebrandly <br />
      <br />
      <h3>Use Our Link</h3>
      If all else fails, just use our link. If you are linking to the feedback
      form from an email or webpage you can hide link behind a hyperlink.
      <br />
      example -
      <router-link :to="{ path: '/console/survey/' + token }"
        >Click Here for Survey</router-link
      >
      If you are using it on printed materials we advise using one of the first
      two options.
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardFeedbackURLCode",
  data() {
    return {
      token: this.$route.params.token,
      propertyName: this.$route.params.property_name
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 21px;
}
h3 {
  font-size: 19px;
  font-weight: bold;
  margin-bottom: 0;
}
#alerts {
  lost-utility: clearfix;
}
textarea {
  width: 800px;
  height: 73px;
  padding: 5px 10px;
  outline: none;
  font-family: Consolas, sans-serif;
}
code {
  display: block;
  overflow-x: auto;
  font-weight: bold;
  color: #f8f8f2;
  background: #000000;
  padding: 15px;
  font-family: consolas, courier, monospace;
  width: 800px;
  border-radius: 3px;
}
code span {
  font-weight: bold;
}
code .keyword {
  color: #f92672;
}
code .function {
  color: #66d9ef;
}
code .parameter {
  color: #e6db74;
}
code .anonymous {
  color: #f92672;
}
@media (max-width: 835px) {
  textarea {
    width: 100%;
  }
  code {
    width: 100%;
  }
}
</style>
